import {source} from 'unist-util-source'
import {SKIP, visit} from 'unist-util-visit'

import type {CopilotMarkdownExtension, RehypeHtmlTransformer} from '../extension'

const trustedDomains = [
  'raw.githubusercontent.com/',
  'private-user-images.githubusercontent.com/',
  'avatars.githubusercontent.com/',
  'gist.github.com/assets/',
]

const ensureTrustedSource: RehypeHtmlTransformer = (tree, file) =>
  visit(tree, (node, index, parent) => {
    if (node.type !== 'element') return
    if (node.tagName === 'img' && 'src' in node.properties) {
      const src = node.properties.src as string
      let url: URL | undefined = undefined
      try {
        url = new URL(src, window.location.origin)
      } catch {
        // ignore
      }
      const path = url ? url.hostname + url.pathname : ''
      if (!url || !trustedDomains.some(domain => path.startsWith(domain))) {
        const md = source(file, node) ?? ''
        const spanNode = {
          type: 'element' as const,
          tagName: 'span',
          properties: {},
          children: [
            {
              type: 'text' as const,
              value: md,
            },
          ],
        }
        if (parent && typeof index === 'number') {
          parent.children[index] = spanNode
          return [SKIP, index]
        }
      }
    }
  })

export default function imagesExtension(): CopilotMarkdownExtension {
  return {
    transformHtml: ensureTrustedSource,
  }
}
